import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';
import { TextField, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';

import SearchIcon from '@mui/icons-material/Search';

import FilterPanel from './FilterPanel';

const useStyles = makeStyles()(() => ({
  input: { fontSize: '1rem', paddingLeft: '8px' },
}));

function Search({ value, filterProps, updateQuickFilter, ...props }) {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <TextField
        {...props}
        onChange={e => {
          updateQuickFilter(e.target.value);
        }}
        placeholder={t('smartmessaging.quickSearch')}
        InputProps={{
          classes: { input: `${classes.input} ` },
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon style={{ fill: '#b6b6b6' }} />
            </InputAdornment>
          ),
        }}
      />
      <FilterPanel {...filterProps} open={!!filterProps.selectedFilters.length} />
    </>
  );
}

Search.propTypes = {
  value: PropTypes.string,
  filterProps: PropTypes.object.isRequired,
  updateQuickFilter: PropTypes.func.isRequired,
};
Search.defaultProps = { value: '' };

export default Search;
